module.exports = __webpack_public_path__ + "img/6X6 ALICIA QR GESTION WHATSAAP_page-0001.9c58f391.jpg";